import { Injectable } from '@angular/core';
import { MatDrawer, MatDrawerToggleResult } from '@angular/material/sidenav';
import { Location } from '@angular/common';
import { Router,NavigationEnd  } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private configLayoutLeftDrawer: MatDrawer;
  private sidebarDrawer: MatDrawer;

  private history: string[] = [];
  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  public setSideDrawer(drawer: MatDrawer): void {
    this.sidebarDrawer = drawer;
  }

  public openSideDrawer(): Promise<MatDrawerToggleResult> {
    return this.sidebarDrawer.open();
  }

  public closeSideDrawer(): Promise<MatDrawerToggleResult> {
    return this.sidebarDrawer.close();
  }
  
  setConfigLayoutLeftDrawer(drawer: MatDrawer): void {
    this.configLayoutLeftDrawer = drawer;
  }

  getConfigLayoutLeftDrawer(): MatDrawer {
    return this.configLayoutLeftDrawer;
  }
  
  back(): void {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
  }
}
